import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SynthLabApp from './lib/SynthLabApp';
import reportWebVitals from './reportWebVitals';
import {SynthKitConfig} from "./lib/synthesizer/SynthKitConfig";

const audioContext = new (window.AudioContext || window.webkitAudioContext)({
  latencyHint: 'interactive'
});
const analyser = audioContext.createAnalyser();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SynthLabApp
        analyser={analyser}
        appTitle={"SynthEngineLab"}
        audioContext={audioContext}
        showVisualizer={true}
        kitConfig={SynthKitConfig}
        setKitConfig={()=>{}}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
